var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "avue-form",
        {
          attrs: { option: _vm.optionPlan },
          on: { submit: _vm.submitPlan },
          model: {
            value: _vm.formPlan,
            callback: function ($$v) {
              _vm.formPlan = $$v
            },
            expression: "formPlan",
          },
        },
        [
          _c(
            "template",
            { slot: "menuForm" },
            [
              _vm.isSubmitted && (!_vm.readOnly || _vm.forceModify)
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-edit" },
                      on: { click: _vm.modifyPlan },
                    },
                    [_vm._v("\n\t\t\t\t修改\n\t\t\t")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.insureType == 13
            ? _c("template", { slot: "insuredItem1Label" }, [
                _c("div", [_vm._v("意外医药补偿（每次意外事故限额）")]),
                _c("div", [
                  _vm._v(
                    "（中国大陆境内医药费用仅限当地社保规定个人自负部分）"
                  ),
                ]),
                _c("div", [_vm._v("（含救护车费用年度累计限额RMB1,000）")]),
              ])
            : _vm._e(),
          _vm.insureType == 13
            ? _c("template", { slot: "insuredItem2Label" }, [
                _c("div", [_vm._v("意外每日住院津贴")]),
                _c("div", [_vm._v("（每一保险年度总赔偿日数以180天为限）")]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.confirmDialogVisible,
            center: "",
            title: "提示",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.confirmDialogVisible = $event
            },
          },
        },
        [
          _c("el-row", [
            _vm._v("\n\t\t\t当前选择的保额为\n\t\t\t"),
            _c(
              "span",
              { staticStyle: { "font-weight": "bold", color: "red" } },
              [_vm._v(_vm._s(_vm.formPlan.coverage) + "万")]
            ),
            _vm._v("\n\t\t\t，为了保障您的权益，请勾选确认：\n\t\t"),
          ]),
          _c(
            "el-row",
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.planWarning1Checked,
                    callback: function ($$v) {
                      _vm.planWarning1Checked = $$v
                    },
                    expression: "planWarning1Checked",
                  },
                },
                [
                  _vm._v(
                    "我已确认" +
                      _vm._s(_vm.formPlan.coverage) +
                      "万保额是符合要求的"
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.planWarning2Checked,
                    callback: function ($$v) {
                      _vm.planWarning2Checked = $$v
                    },
                    expression: "planWarning2Checked",
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t我已了解“按照相关法规，" +
                      _vm._s(_vm.formPlan.coverage) +
                      "万保额已无法满足工伤事故赔偿最低标准”\n\t\t\t"
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function ($event) {
                      _vm.confirmDialogVisible = false
                    },
                  },
                },
                [_vm._v("更改保额")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled:
                      !_vm.planWarning1Checked || !_vm.planWarning2Checked,
                    size: "medium",
                    type: "primary",
                  },
                  on: { click: _vm.confirmPlan },
                },
                [_vm._v("\n\t\t\t\t确认\n\t\t\t")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowNoFeeRate,
            center: "",
            title: "提示",
            top: "30vh",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowNoFeeRate = $event
            },
          },
        },
        [
          _c("div", { staticClass: "u-flex u-row-center u-m-b-10 u-m-t-10" }, [
            _c("span", { staticClass: "red-bold" }, [
              _vm._v(
                "本保单不承保货车司机和随车人员参与装卸货物有关工作发生的工伤和意外伤害的赔偿责任。"
              ),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onNoFeeRateAgree } }, [
                _vm._v("谢谢，投/被保险人不同意此告知。"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.isShowNoFeeRate = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t已知悉，我已告知投/被保险人，并取得投/被保险人的同意。\n\t\t\t"
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }